<template>
  <el-container class="classManger">
    <el-aside class="classManger-left">
      <div class="sidebar">
        <el-button
          type="text"
          style="float:right;margin-top:5px;margin-right:10px"
          @click="openCampusDialog()"
          icon="el-icon-plus"
          >添加省份</el-button
        >
        <div class="title">校区树</div>
        <div class="teachingPlan-search">
          <el-tree
            :data="CampusTreeData"
            :props="CampusProps"
            :highlight-current="true"
            :expand-on-click-node="false"
            class="teachingPlan-tree"
            ref="tree"
            node-key="id"
            current-node-key
          >
            <span
              class="span-ellipsis"
              slot-scope="{ node, data }"
              @click="handleNodeClick(data)"
              @mousemove="mousemoveShow = data"
              @mouseleave="mousemoveShow = ''"
            >
              <span :title="data.name">
                {{ data.name }}
                <span v-if="mousemoveShow == data">
                  <i
                    class="left-top-bottom el-icon-delete"
                    @click="
                      (NodeClick = false), deleteCampus(node.level, data.id)
                    "
                  ></i>
                  <i
                    class="left-top-bottom el-icon-edit"
                    @click="
                      (NodeClick = false),
                        getCampusList(),
                        openEditCampusDialog(node.level, data)
                    "
                  ></i>
                  <i
                    v-if="node.level < 3"
                    class="el-icon-plus left-top-bottom"
                    @click="
                      (NodeClick = false), openCampusDialog(node.level, data.id)
                    "
                  ></i>
                </span>
              </span>
            </span>
          </el-tree>
        </div>
      </div>
    </el-aside>
    <el-main class="classManger-right">
      <el-card class="sidebarRight">
        <!-- <div class="title">教室列表</div> -->
        <div>
          <el-row :gutter="20">
            <el-col :sm="12" :md="6" :lg="6">
              <el-input
                v-model="inp"
                style="width: 100%"
                placeholder="请输入教室名称"
                clearable
                v-auth="'classroom_/classroom/pageList'"
              ></el-input>
            </el-col>
            <el-col :sm="12" :md="6" :lg="6">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="(currentPage = 1), getPageList()"
                v-auth="'classroom_/classroom/pageList'"
                >查询</el-button
              >
            </el-col>
            <el-col :sm="12" :md="10" :lg="10" style="float: right">
              <el-button
                type="primary"
                style="float: right; margin-left: 20px"
                @click="classroomSchedule()"
                v-auth="'teacher_/classInfo/classroomCalendarInfo'"
                >教室排课情况</el-button
              >
              <el-button
                v-auth="'classroom_/classroom/addClassroom'"
                type="primary"
                style="float: right; margin-left: 20px"
                @click="getCampusList(), (showAddDialog = true)"
                icon="el-icon-plus"
                >添加教室</el-button
              >
            </el-col>
          </el-row>
          <el-table
            v-auth="'classroom_/classroom/pageList'"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
            class="teacherTable"
            :data="tableData"
            border
            style="width: 100%; margin-top: 20px"
          >
            <el-table-column
              prop="name"
              label="教室名称"
              sortable
              width="180"
            ></el-table-column>
            <el-table-column
              prop="campus.name"
              label="所属校区"
            ></el-table-column>
            <el-table-column prop="capacity" label="容纳人数"></el-table-column>
            <el-table-column prop="address" label="所在地点"></el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <div class="operationGroup">
                  <!-- <el-button type="text" @click="getCampusList(),showDialog(scope.row)">编辑</el-button>
                  <el-button @click="del(scope.row)" type="text">删除</el-button>-->
                  <span
                    v-auth="'classroom_/classroom/updateClassroom'"
                    class="el-icon-edit icon-style"
                    @click="getCampusList(), showDialog(scope.row)"
                  ></span>
                  <span
                    class="el-icon-delete icon-style"
                    @click="del(scope.row)"
                    v-auth="'classroom_/classroom/deleteClassroom'"
                  ></span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="table_bottom">
            <!-- <span style="float: left;line-height: 30px;">
                显示第{{start}}条到第{{end}}条记录,总共{{total}}条数据,每页显示
                <el-select
                  size="mini"
                  @change="pageChange"
                  class="pageNumber"
                  style="width: 62px;"
                  v-model="pageSize"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in pageNumber"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>条记录
            </span>-->
            <el-pagination
              v-auth="'classroom_/classroom/pageList'"
              style="float: left"
              background
              layout="prev, pager, next, jumper,  total, sizes"
              :total="total"
              :page-size.sync="pageSize"
              :current-page.sync="currentPage"
              @size-change="sizeChange"
              @current-change="currentChange"
            ></el-pagination>
          </div>
          <div style="clear: both"></div>
        </div>

        <!-- 添加校区 -->
        <el-dialog
          @close="clearForm"
          class="addDialog"
          :title="addCampusName"
          :width="addwidth"
          :visible.sync="addCampusDialog"
        >
          <el-form
            :model="addCampusForm"
            status-icon
            :rules="campusFormRules"
            ref="addCampusForm"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-form-item :label="campusLableName" prop="name">
              <el-input
                v-model="addCampusForm.name"
                autocomplete="off"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="active">
              <el-radio-group v-model="addCampusForm.active">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="-1">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button @click="clearAddCampusForm">重置</el-button>
              <el-button type="primary" @click="addCampus">提交</el-button>
            </el-form-item>
          </el-form>
          <!-- <div slot="footer" class="dialog-footer" style="text-align: right">
              <el-button @click="clearAddCampusForm">重置</el-button>
              <el-button type="primary" @click="addCampus">提交</el-button>
            </div> -->
        </el-dialog>

        <!-- 编辑校区 -->
        <el-dialog
          @close="clearForm"
          class="addDialog"
          :title="editCampusName"
          :width="addwidth"
          :visible.sync="editCampusDialog"
        >
          <el-form
            :model="editCampusForm"
            status-icon
            :rules="campusFormRules"
            ref="editCampusForm"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-form-item :label="campusLableName" prop="name">
              <el-input
                v-model="editCampusForm.name"
                autocomplete="off"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="active">
              <el-radio-group v-model="editCampusForm.active">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="-1">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button @click="clearEditCampusForm">重置</el-button>
              <el-button type="primary" @click="updateCampus">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 添加教室弹出框 -->
        <el-dialog
          @close="clearForm"
          class="addDialog"
          title="添加教室"
          :width="addwidth"
          :visible.sync="showAddDialog"
        >
          <el-form
            :model="form"
            status-icon
            :rules="rules"
            ref="addForm"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-form-item label="校区" prop="campusId">
              <!-- <el-select style="width: 100%;" v-model="form.campusId" placeholder="请选择">
                  <el-option
                    v-for="item in campusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
              </el-select>-->
              <el-cascader
                style="width: 100%"
                clearable
                v-model="form.campusId"
                :show-all-levels="false"
                :props="CampusProps"
                placeholder="请选择所属校区"
                :options="campusList"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="教室名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入教室名称"
                autocomplete="off"
                maxlength="30"
              ></el-input>
            </el-form-item>

            <el-form-item label="容纳人数" prop="capacity">
              <el-input
                type="number"
                placeholder="请输入教室容纳人数"
                v-model="form.capacity"
                maxlength="10"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请输入地址"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                placeholder="请输入备注"
                maxlength="200"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addClassRoom">提交</el-button>
              <el-button @click="clearForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <el-dialog
          @close="clearForm"
          class="addDialog"
          title="编辑教室"
          :width="addwidth"
          :visible.sync="showEditorDialog"
        >
          <el-form
            :model="form"
            status-icon
            :rules="rules"
            ref="updateForm"
            label-width="80px"
            class="demo-ruleForm"
          >
            <el-form-item label="校区" prop="campusId">
              <!-- <el-select style="width: 100%;" v-model="form.campusId" placeholder="请选择">
                  <el-option
                    v-for="item in campusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
              </el-select>-->
              <el-cascader
                style="width: 100%"
                clearable
                v-model="form.campusId"
                :show-all-levels="false"
                :props="CampusProps"
                placeholder="请选择所属校区"
                :options="campusList"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="教室名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入教室名称"
                autocomplete="off"
                maxlength="30"
              ></el-input>
            </el-form-item>

            <el-form-item label="容纳人数" prop="capacity">
              <el-input
                type="number"
                placeholder="请输入教室容纳人数"
                v-model="form.capacity"
                maxlength="10"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请输入地址"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                placeholder="请输入备注"
                maxlength="200"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="updateClassroom"
                >提交</el-button
              >
              <el-button @click="clearForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import tree from "./tree";
export default {
  data() {
    return {
      blockAddCampus: false,
      blockUpdateCampus: false,
      blockAddClassRoom: false,
      blockUpdateClassroom: false,
      addCampusName: "添加省份",
      editCampusName: "修改校区",
      campusLableName: "省份名称",
      mousemoveShow: "",
      id: "", //校区id
      showEditorDialog: false,
      showAddDialog: false,
      NodeClick: true,
      loading: true, //表格是否加载中
      inp: "", //输入框绑定的值
      defaultProps: {
        children: "list",
        label: "name"
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      form: {
        name: "",
        campusId: "",
        address: "",
        capacity: "",
        remark: ""
      },
      addCampusForm: {
        active: 1,
        parentId: "",
        name: ""
      },
      editCampusForm: {},
      addCampusDialog: false,
      editCampusDialog: false,
      CampusTreeData: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      campusFormRules: {
        name: [
          {
            required: true,
            message: "请输入校区名称",
            trigger: "blur"
          }
        ],
        active: [
          {
            required: true,
            message: "请选择是否禁用",
            trigger: "change"
          }
        ]
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入教室名称",
            trigger: "blur"
          }
        ],
        campusId: [
          {
            required: true,
            message: "请选择校区",
            trigger: "blur"
          }
        ],
        capacity: [
          {
            required: true,
            message: "请输入教室容量",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "请输入校区地址",
            trigger: "blur"
          }
        ]
      },
      addwidth: "30%",
      campusList: [],
      campusId: null,
      start: "",
      end: "",
      pageNumber: [
        {
          value: 10,
          label: 10
        },
        {
          value: 20,
          label: 20
        }
      ],
      total: 0
    };
  },
  components: {
    tree
  },
  methods: {
    classroomSchedule() {
      this.$router.push("/classroomSchedule");
    },
    sizeChange() {
      this.pageChange();
    },
    currentChange() {
      this.pageChange();
    },
    pageChange() {
      //分页发生变化时
      let data;
      if (this.inp && !this.campusId) {
        data = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          sortName: "create_time",
          sortOrder: "desc",
          name: this.inp,
          mobile: this.inp
        };
      } else {
        data = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          sortName: "create_time",
          sortOrder: "desc",
          campusId: this.campusId
        };
      }
      this.api.classroom.pageList(data).then(result => {
        if (result.success) {
          this.loading = false;
          this.tableData = result.data.records;
        }
      });
    },
    paginationInit() {
      if (this.currentPage == 1 && this.total <= this.pageSize) {
        this.start = 1;
        this.end = this.total;
      } else if (this.currentPage * this.pageSize < this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.currentPage * this.pageSize;
      } else if (this.currentPage * this.pageSize >= this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.total;
      }
    },
    updateClassroom() {
      if (this.blockUpdateClassroom) {
        return false;
      }
      this.blockUpdateClassroom = true;
      this.$refs.updateForm.validate(val => {
        if (val) {
          if (typeof this.form.campusId == "object") {
            let index = this.form.campusId.length;
            this.form.campusId = this.form.campusId[index - 1];
          }
          let form = {};
          Object.assign(form, this.form, { id: this.id });
          this.api.classroom.updateClassroom(form).then(result => {
            if (result.success) {
              this.showEditorDialog = false;
              this.blockUpdateClassroom = false;
              this.$message.success(result.message);
              this.getPageList();
            } else {
              this.blockUpdateClassroom = false;
              this.$message.success(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    showDialog(val) {
      this.showEditorDialog = true;
      this.form = {
        name: val.name,
        campusId: val.campusId,
        address: val.address,
        capacity: val.capacity,
        remark: val.remark
      };
      this.id = val.id;
      // var form={};
      // Object.assign(form,this.form,{id:val.id});
    },
    del(v) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(result => {
          this.api.classroom.deleteClassroom([{ id: v.id }]).then(result => {
            if (result.success) {
              this.showEditorDialog = false;
              this.$message.success(result.message);
              const totalPage = Math.ceil((this.total - 1) / this.pageSize);
              const pagenum =
                this.currentPage > totalPage ? totalPage : this.currentPage;
              this.currentPage = pagenum < 1 ? 1 : pagenum;
              this.getPageList();
            } else {
              this.$message.success(result.message);
            }
          });
        })
        .catch(() => {});
    },
    // getCampusList() {
    //   this.api.campus.getCampusList({}).then(result => {
    //     // console.log(result)
    //     if (result.success) {
    //       for (var i = 0; i < result.data.length; i++) {
    //         let obj = {
    //           value: result.data[i].id,
    //           label: result.data[i].name
    //         };
    //         this.campusList[i] = obj;
    //       }
    //     }
    //   });
    // },
    handleNodeClick(data) {
      console.log("data", data);
      if (this.NodeClick == true) {
        if (data.children.length > 0) {
          let item = data.children[0];
          if (item.children.length > 0) {
            this.form.campusId = data.children[0].id;
            // let items = item.children[0];
            // if (items.children.length > 0) {
            //   console.log("333333333")
            //   this.form.campusId = data.children[0].children[0].id;
            // } else {
            //   this.form.campusId = data.children[0].children[0].id;
            // }
          } else {
            this.form.campusId = data.children[0].id;
          }
        } else {
          this.form.campusId = data.id;
        }
        this.campusId = data.id;
        this.getPageList();
      }
    },
    openCampusDialog(level, id) {
      if (level) {
        this.addCampusForm.level = level + 1;
        if (level === 1) {
          this.addCampusName = "添加城市";
          this.campusLableName = "城市名称";
        }
        if (level === 2) {
          this.addCampusName = "添加校区";
          this.campusLableName = "校区名称";
        }
      } else {
        this.addCampusName = "添加省份";
        this.campusLableName = "省份名称";
        this.addCampusForm.level = 1;
      }
      if (id) {
        this.addCampusForm.parentId = id;
      } else {
        this.addCampusForm.parentId = "";
      }
      this.NodeClick = true;
      this.addCampusDialog = true;
    },
    openEditCampusDialog(level, data) {
      if (level === 1) {
        this.editCampusName = "编辑省份";
        this.campusLableName = "省份名称";
      }
      if (level === 2) {
        this.editCampusName = "编辑城市";
        this.campusLableName = "城市名称";
      }
      if (level === 3) {
        this.editCampusName = "编辑校区";
        this.campusLableName = "校区名称";
      }
      this.editCampusForm.id = data.id;
      this.getCampus(data.id);
      this.NodeClick = true;
      this.editCampusDialog = true;
    },
    getCampus(data) {
      this.api.campus.getCampus({ id: data }).then(result => {
        if (result.success) {
          this.editCampusForm = result.data;
          if (this.editCampusForm.parentId === "1") {
            this.editCampusForm.parentId = "";
          }
        }
      });
    },
    addCampus() {
      if (this.blockAddCampus) {
        return false;
      }
      this.blockAddCampus = true;
      this.$refs.addCampusForm.validate(val => {
        if (val) {
          this.api.campus.addCampus(this.addCampusForm).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.addCampusDialog = false;
              this.blockAddCampus = false;
              this.getCampusTree();
              this.clearAddCampusForm();
            } else {
              this.$message.error(result.message);
              this.blockAddCampus = false;
            }
          });
        }
      });
    },
    updateCampus() {
      if (this.blockUpdateCampus) {
        return false;
      }
      this.blockUpdateCampus = true;
      this.$refs.editCampusForm.validate(val => {
        if (val) {
          this.api.campus.updateCampus(this.editCampusForm).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.editCampusDialog = false;
              this.blockUpdateCampus = false;
              this.getCampusTree();
              this.clearEditCampusForm();
            } else {
              this.$message.error(result.message);
              this.blockUpdateCampus = false;
            }
          });
        }
      });
    },
    deleteCampus(level, id) {
      let name = "";
      if (level === 1) {
        name = "省份（关联子校区）";
      }
      if (level === 2) {
        name = "城市（关联子校区）";
      }
      if (level === 3) {
        name = "校区";
      }
      this.$confirm("将会删除此" + name + "，是否确认删除？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.campus.deleteCampus([{ id: id }]).then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.NodeClick = true;
            this.getCampusTree();
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    getPageList() {
      this.loading = true;
      let data = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        sortName: "create_time",
        sortOrder: "desc",
        name: this.inp,
        campusId: this.campusId
      };
      this.loading = true;
      this.api.classroom.pageList(data).then(result => {
        if (result.success) {
          this.tableData = result.data.records;
          this.total = Number(result.data.total);
          this.loading = false;
          this.paginationInit();
        }
      });
    },
    // setIdEvent(val) {
    //   this.campusId = val.id;
    //   this.pageSize = 10;
    //   this.currentPage = 1;
    //   this.inp = "";
    //   var data = {
    //     pageNumber: this.currentPage,
    //     pageSize: this.pageSize,
    //     sortName: "create_time",
    //     sortOrder: "desc",
    //     campusId: val.id
    //   };
    //   this.api.classroom.pageList(data).then(result => {
    //     // console.log(result)
    //     if (result.success) {
    //       this.tableData = result.data.records;
    //     }
    //   });
    // },
    getCampusTree() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(res => {
          for (let item of res.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      itemss.children = [];
                    } else {
                    }
                  }
                } else {
                }
              }
            } else {
            }
          }
          this.CampusTreeData = res.data;
          if (this.CampusTreeData.length === 0) {
            this.loading = false;
            this.$message.error("暂无校区，请添加校区");
          }
          let data = this.CampusTreeData[0];
          if (data.children.length > 0) {
            this.campusId = data.id;
            this.getPageList();
            let item = data.children[0];
            if (item.children.length > 0) {
              let items = item.children[0];
              if (items.children.length > 0) {
                // delete items.children;
                // let itemss = items.children[0];
                // if (itemss.children.length > 0) {
                // } else {
                //   this.form.campusId =
                //     data.children[0].children[0].children[0].id;
                //   this.campusId = data.children[0].children[0].children[0].id;
                //   this.getPageList();
                // }
              } else {
                this.form.campusId = data.children[0].children[0].id;
                // this.campusId = data.children[0].children[0].id;
                // this.getPageList();
              }
            } else {
              this.form.campusId = data.children[0].id;
              // this.campusId = data.children[0].id;
              // this.getPageList();
            }
          } else {
            this.form.campusId = data.id;
            this.campusId = data.id;
            this.getPageList();
          }

          this.$nextTick(function() {
            this.$refs.tree.setCurrentKey(this.campusId);
          });
        })
        .catch(error => {});
    },
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    setaddDialogwidth() {
      //设置添加老师弹窗大小
      var width = document.body.clientWidth;
      if (width < 560) {
        this.addwidth = "80%";
      } else if (width < 790) {
        this.addwidth = "70%";
      } else if (width < 970) {
        this.addwidth = "50%";
      } else if (width < 1300) {
        this.addwidth = "40%";
      } else {
        this.addwidth = "30%";
      }
    },
    clearForm() {
      this.form = {
        name: "",
        address: "",
        capacity: "",
        remark: ""
      };
    },
    clearAddCampusForm() {
      (this.addCampusForm.name = ""), (this.addCampusForm.active = 1);
    },
    clearEditCampusForm() {
      (this.editCampusForm.name = ""), (this.editCampusForm.active = 1);
    },
    addClassRoom() {
      if (this.blockAddClassRoom) {
        return false;
      }
      this.blockAddClassRoom = true;
      this.$refs.addForm.validate(val => {
        if (val) {
          if (typeof this.form.campusId == "object") {
            let index = this.form.campusId.length;
            this.form.campusId = this.form.campusId[index - 1];
          }
          this.api.classroom.addClassroom(this.form).then(result => {
            if (result.success) {
              this.$message.success(result.message);
              this.blockAddClassRoom = false;
              this.getPageList();
              this.clearForm();
              this.showAddDialog = false;
            } else {
              this.blockAddClassRoom = false;
              this.$message.error(result.message);
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    addCampusDialog: function(newVal) {
      if (!newVal) {
        this.$refs.addCampusForm.resetFields();
        this.addCampusForm.parentId = "";
        this.addCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
    editCampusDialog: function(newVal) {
      if (!newVal) {
        this.$refs.editCampusForm.resetFields();
        this.editCampusForm.parentId = "";
        this.editCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    }
  },
  created() {
    this.getCampusTree();
  },
  mounted() {
    window.onresize = () => {
      this.setaddDialogwidth();
    };
  }
};
</script>
<style scoped>
.classManger-left {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
  /* box-shadow:0 2px 12px 0 rgba(0,0,0,.1); */
  /* border-right: 1px solid rgba(238, 238, 238, 1); */
}
.classManger-right {
  padding: 0px 20px !important;
}
</style>
<style lang="less">
.classManger {
  .cell {
    position: relative;
  }
}

.sidebar,
.sidebarRight {
  background: white;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.teachingPlan-search {
  padding: 0px 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.teachingPlan-tree {
  margin-top: 10px;
}
.classroom-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/classroom/index.vue